(function () {
  'use strict';

  var config = window.CinotonComponentConfig || {};
  var assets = config.assets || {};
  var loads = {};
  var replayedClicks = new WeakSet();
  var replayedSubmits = new WeakSet();
  var replayedChanges = new WeakSet();
  var pendingSwipes = new Map();
  var productSelector = 'product-form, variant-selects, variant-radios, product-slider, product-add-to-cart-sticky, side-panel-links';

  function isReady(name) {
    if (name === 'product') {
      return Boolean(customElements.get('product-form') && customElements.get('product-slider'));
    }
    if (name === 'slideshow') {
      return Boolean(customElements.get('slide-show'));
    }
    if (name === 'predictive') {
      return window.__cinotonPredictiveSearchReady === true;
    }
    return false;
  }

  function load(name, reason) {
    if (isReady(name)) return Promise.resolve();
    if (loads[name]) return loads[name];
    if (!assets[name]) return Promise.resolve();

    loads[name] = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-cinoton-component="' + name + '"]');
      var script = existing || document.createElement('script');

      function onLoad() {
        script.removeEventListener('load', onLoad);
        script.removeEventListener('error', onError);
        if (!isReady(name)) {
          onError();
          return;
        }
        if (name === 'product') reconcileAllVariantFailures();
        document.dispatchEvent(new CustomEvent('cinoton:component-loaded', {
          detail: { name: name, reason: reason || 'requested' }
        }));
        resolve();
      }

      function onError() {
        script.removeEventListener('load', onLoad);
        script.removeEventListener('error', onError);
        if (script.dataset.cinotonComponent === name) script.remove();
        delete loads[name];
        reject(new Error('Unable to load component: ' + name));
      }

      script.addEventListener('load', onLoad, { once: true });
      script.addEventListener('error', onError, { once: true });

      if (!existing) {
        script.src = assets[name];
        script.async = false;
        script.dataset.cinotonComponent = name;
        script.dataset.cinotonLoadReason = reason || 'requested';
        document.head.appendChild(script);
      }
    });

    return loads[name];
  }

  function loadWhenIdle(name, reason) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () {
        load(name, reason).catch(function () {});
      }, { timeout: 2000 });
    } else {
      window.setTimeout(function () {
        load(name, reason).catch(function () {});
      }, 0);
    }
  }

  function observeComponents() {
    document.querySelectorAll('.announcement-bar-section slide-show').forEach(function () {
      load('slideshow', 'announcement-visible').catch(function () {});
    });

    if (typeof IntersectionObserver !== 'function') return;

    var productObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        load('product', 'near-viewport').catch(function () {});
      });
    }, { rootMargin: '400px 0px' });

    document.querySelectorAll(productSelector).forEach(function (element) {
      productObserver.observe(element);
    });

    var slideshowObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        load('slideshow', 'near-viewport').catch(function () {});
      });
    }, { rootMargin: '400px 0px' });

    document.querySelectorAll('slide-show').forEach(function (element) {
      if (element.closest('.announcement-bar-section')) return;
      slideshowObserver.observe(element);
    });
  }

  function toggleSearchDrawerFallback(trigger) {
    var drawer = document.getElementById('Search-Drawer');
    if (!drawer) return;
    var willOpen = !drawer.classList.contains('active');
    if (willOpen) drawer.opener = trigger;
    document.body.classList.toggle('open-cc', willOpen);
    drawer.classList.toggle('active', willOpen);
    if (willOpen) {
      var input = drawer.querySelector('input[type="search"]');
      if (input) window.setTimeout(function () { input.focus({ preventScroll: true }); }, 100);
      if (typeof window.dispatchCustomEvent === 'function') window.dispatchCustomEvent('search:open');
    } else if (trigger && typeof trigger.focus === 'function') {
      trigger.focus();
    }
  }

  function replayClickAfterLoad(event, name, target) {
    if (replayedClicks.has(target) || isReady(name)) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    replayedClicks.add(target);
    load(name, 'first-click')
      .then(function () {
        window.requestAnimationFrame(function () {
          target.click();
          replayedClicks.delete(target);
        });
      })
      .catch(function () {
        replayedClicks.delete(target);
        if (name === 'predictive') toggleSearchDrawerFallback(target);
      });
    return true;
  }

  document.addEventListener('pointerover', function (event) {
    if (event.target.closest('.thb-quick-search')) {
      load('predictive', 'pointer-intent').catch(function () {});
      return;
    }
    if (event.target.closest('quick-view, ' + productSelector)) {
      load('product', 'pointer-intent').catch(function () {});
      return;
    }
    if (event.target.closest('slide-show')) {
      load('slideshow', 'pointer-intent').catch(function () {});
    }
  }, { passive: true, capture: true });

  document.addEventListener('focusin', function (event) {
    if (event.target.closest('.thb-quick-search')) {
      load('predictive', 'focus-intent').catch(function () {});
      return;
    }
    if (event.target.closest('quick-view, ' + productSelector)) {
      load('product', 'focus-intent').catch(function () {});
      return;
    }
    if (event.target.closest('slide-show')) {
      load('slideshow', 'focus-intent').catch(function () {});
    }
  }, true);

  document.addEventListener('touchstart', function (event) {
    if (event.target.closest('.thb-quick-search')) {
      load('predictive', 'touch-intent').catch(function () {});
      return;
    }
    if (event.target.closest('quick-view, ' + productSelector)) {
      load('product', 'touch-intent').catch(function () {});
      return;
    }
    if (event.target.closest('slide-show')) {
      load('slideshow', 'touch-intent').catch(function () {});
    }
  }, { passive: true, capture: true });

  function rememberSwipe(event, point) {
    var slideshow = event.target.closest && event.target.closest('slide-show');
    if (!slideshow || isReady('slideshow')) return;
    if (slideshow.matches('.image-with-text-slideshow--content, .media-with-tabs--media')) return;
    var key = event.pointerId != null ? event.pointerId : 'touch';
    pendingSwipes.set(key, {
      slideshow: slideshow,
      x: point.clientX,
      y: point.clientY
    });
    load('slideshow', 'swipe-intent').catch(function () {});
  }

  function finishSwipe(event, point) {
    var key = event.pointerId != null ? event.pointerId : 'touch';
    var start = pendingSwipes.get(key);
    if (!start) return;
    pendingSwipes.delete(key);
    var slideshow = start.slideshow;
    var deltaX = point.clientX - start.x;
    var deltaY = point.clientY - start.y;
    if (Math.abs(deltaX) < 30 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    load('slideshow', 'first-swipe').then(function () {
      window.requestAnimationFrame(function () {
        var flickity = window.Flickity && window.Flickity.data(slideshow);
        if (!flickity) return;
        var next = deltaX < 0;
        if (document.dir === 'rtl') next = !next;
        if (next) flickity.next();
        else flickity.previous();
      });
    }).catch(function () {});
  }

  if ('PointerEvent' in window) {
    document.addEventListener('pointerdown', function (event) {
      if (event.isPrimary === false) return;
      rememberSwipe(event, event);
    }, { passive: true, capture: true });
    document.addEventListener('pointerup', function (event) {
      if (event.isPrimary === false) return;
      finishSwipe(event, event);
    }, true);
    document.addEventListener('pointercancel', function (event) {
      pendingSwipes.delete(event.pointerId);
    }, true);
  } else {
    document.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      rememberSwipe(event, event.touches[0]);
    }, { passive: true, capture: true });
    document.addEventListener('touchend', function (event) {
      if (event.changedTouches.length !== 1) return;
      finishSwipe(event, event.changedTouches[0]);
    }, true);
    document.addEventListener('touchcancel', function () {
      pendingSwipes.delete('touch');
    }, true);
  }

  function isCarouselKey(event) {
    return event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar';
  }

  document.addEventListener('keydown', function (event) {
    if (!isCarouselKey(event) || isReady('slideshow')) return;
    var control = event.target.closest && event.target.closest('slide-show .flickity-prev, slide-show .flickity-next');
    if (!control) return;
    event.preventDefault();
    load('slideshow', 'keyboard-intent').catch(function () {});
  }, true);

  document.addEventListener('keyup', function (event) {
    if (!isCarouselKey(event) || isReady('slideshow')) return;
    var control = event.target.closest && event.target.closest('slide-show .flickity-prev, slide-show .flickity-next');
    if (!control) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var key = event.key;
    load('slideshow', 'first-key').then(function () {
      control.dispatchEvent(new KeyboardEvent('keyup', { key: key, bubbles: true }));
    }).catch(function () {});
  }, true);

  document.addEventListener('click', function (event) {
    var searchTrigger = event.target.closest('.thb-quick-search');
    if (searchTrigger && replayClickAfterLoad(event, 'predictive', searchTrigger)) return;

    var quickView = event.target.closest('quick-view');
    if (quickView) {
      load('product', 'quick-view').catch(function () {});
      return;
    }

    var slideshow = event.target.closest('slide-show');
    if (!slideshow || isReady('slideshow')) return;
    if (event.target.closest('a[href]')) return;
    replayClickAfterLoad(event, 'slideshow', event.target.closest('button, [role="button"], [tabindex]') || slideshow);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var productForm = form.closest && form.closest('product-form');
    if (!productForm || replayedSubmits.has(form)) return;
    if (isReady('product')) {
      if (productForm.dataset.cinotonVariantUnresolved === 'true') {
        reconcileProductFormVariant(productForm);
      }
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    replayedSubmits.add(form);
    var submitter = event.submitter;

    load('product', 'first-submit')
      .then(function () {
        window.requestAnimationFrame(function () {
          if (productForm.dataset.cinotonVariantUnresolved === 'true') {
            if (!reconcileProductFormVariant(productForm)) {
              replayedSubmits.delete(form);
              showProductLoadError(productForm);
              return;
            }
          }
          replayedSubmits.delete(form);
          if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined);
          else form.submit();
        });
      })
      .catch(function () {
        replayedSubmits.delete(form);
        if (productForm.dataset.cinotonVariantUnresolved === 'true') {
          showProductLoadError(productForm);
          return;
        }
        var variantInput = form.querySelector('[name="id"]');
        if (variantInput && variantInput.value) {
          variantInput.disabled = false;
          form.submit();
        }
      });
  }, true);

  document.addEventListener('change', function (event) {
    var variants = event.target.closest && event.target.closest('variant-selects, variant-radios');
    if (!variants || isReady('product') || replayedChanges.has(variants)) return;
    event.stopImmediatePropagation();
    replayedChanges.add(variants);
    var changedTarget = event.target;
    load('product', 'variant-change')
      .then(function () {
        window.requestAnimationFrame(function () {
          markVariantFailure(variants, false);
          changedTarget.dispatchEvent(new Event('change', { bubbles: true }));
          replayedChanges.delete(variants);
        });
      })
      .catch(function () {
        markVariantFailure(variants, true);
        replayedChanges.delete(variants);
      });
  }, true);

  function showProductLoadError(productForm) {
    var wrapper = productForm && productForm.querySelector('.product-form__error-message-wrapper');
    var message = wrapper && wrapper.querySelector('.product-form__error-message');
    if (!wrapper || !message) return;
    message.textContent = window.theme && window.theme.strings && window.theme.strings.componentLoadError
      ? window.theme.strings.componentLoadError
      : 'There was an error while updating your cart. Please try again.';
    wrapper.hidden = false;
  }

  function markVariantFailure(variants, failed) {
    var section = variants.dataset.section;
    document.querySelectorAll('product-form').forEach(function (productForm) {
      if (section && productForm.dataset.section !== section) return;
      if (failed) {
        productForm.dataset.cinotonVariantUnresolved = 'true';
        showProductLoadError(productForm);
      } else {
        delete productForm.dataset.cinotonVariantUnresolved;
        var wrapper = productForm.querySelector('.product-form__error-message-wrapper');
        if (wrapper) wrapper.hidden = true;
      }
    });
  }

  function reconcileProductFormVariant(productForm) {
    var section = productForm.dataset.section;
    var variants = Array.from(document.querySelectorAll('variant-selects, variant-radios')).find(function (candidate) {
      return !section || candidate.dataset.section === section;
    });
    if (!variants) return false;
    markVariantFailure(variants, false);
    var changedTarget = variants.querySelector('input:checked, select') || variants;
    changedTarget.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function reconcileAllVariantFailures() {
    document.querySelectorAll('product-form[data-cinoton-variant-unresolved="true"]').forEach(function (productForm) {
      reconcileProductFormVariant(productForm);
    });
  }

  function scheduleFallbacks() {
    window.setTimeout(function () {
      if (document.querySelector(productSelector)) loadWhenIdle('product', 'idle-fallback');
      window.setTimeout(function () {
        if (document.querySelector('slide-show')) loadWhenIdle('slideshow', 'idle-fallback');
      }, 750);
    }, Number(config.delay) || 12000);
  }

  window.CinotonComponents = {
    load: load,
    isLoaded: isReady
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeComponents();
      scheduleFallbacks();
    }, { once: true });
  } else {
    observeComponents();
    scheduleFallbacks();
  }
})();
